import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/HomePage.vue'),
        meta: {
            pageKey: 'marketing',
        },
    },
    {
        path: '/dispatching',
        name: 'dispatching',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/DispatchingPage.vue'),
        meta: {
            pageKey: 'marketing',
        },
    },
    {
        path: '/support',
        name: 'support',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/SupportPage.vue'),
        meta: {
            pageKey: 'support',
        },
    },
    {
        path: '/about',
        name: 'about',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/AboutPage.vue'),
        meta: {
            pageKey: 'marketing',
        },
    },
    {
        path: '/enterprise',
        name: 'enterprise',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/landers/EnterpriseLandingPage.vue'),
        meta: {
            pageKey: 'marketing',
        },
    },
    {
        path: '/owner-operator',
        name: 'ownerOperator',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/landers/OwnerOperatorLandingPage.vue'),
        meta: {
            pageKey: 'marketing',
        },
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/legal/PrivacyPage.vue'),
        meta: {
            pageKey: 'legal',
        },
    },
    {
        path: '/terms',
        name: 'terms',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/legal/TermsPage.vue'),
        meta: {
            pageKey: 'legal',
        },
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/ContactPage.vue'),
        meta: {
            pageKey: 'support',
        },
    },
    {
        path: '/resources/haulingcalc',
        name: 'haulingCalculatorMenu',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/resources/HaulingCalculatorMenuPage.vue'),
        meta: {
            pageKey: 'marketing',
        },
    },
    {
        path: '/resources/haulingcalc/give',
        name: 'haulingCalculatorGive',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/resources/HaulingCalculatorGivePage.vue'),
        meta: {
            pageKey: 'marketing',
        },
    },
    {
        path: '/resources/haulingcalc/analyze',
        name: 'haulingCalculatorAnalyze',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/resources/HaulingCalculatorAnalyzePage.vue'),
        meta: {
            pageKey: 'marketing',
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/auth/LoginPage.vue'),
        meta: {
            requireGuest: true,
            pageKey: 'auth',
        },
    },
    {
        path: '/login/forgot',
        name: 'forgotPassword',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/auth/ForgotPasswordPage.vue'),
        meta: {
            pageKey: 'auth',
        },
    },
    {
        path: '/driver/welcome',
        name: 'driverWelcome',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/auth/DriverWelcomePage.vue'),
        meta: {
            pageKey: 'auth',
        },
    },
    {
        path: '/enterprise/welcome',
        name: 'enterpriseWelcome',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/auth/EnterpriseWelcomePage.vue'),
        meta: {
            pageKey: 'auth',
        },
    },
    {
        path: '/login/reset',
        name: 'resetPassword',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/auth/ResetPasswordPage.vue'),
        meta: {
            pageKey: 'auth',
        },
    },
    {
        path: '/login/driverPassword',
        name: 'driverPassword',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/auth/ResetPasswordPage.vue'),
        props: { title: 'Set Password' },
        meta: {
            pageKey: 'auth',
        },
    },
    {
        path: '/confirmEmailChange',
        name: 'confirmEmailChange',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/auth/ConfirmEmailChangePage.vue'),
        meta: {
            pageKey: 'auth',
        },
    },
        {
        path: '/pricing',
        name: 'pricing',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/onboarding/GetStartedPage.vue'),
        meta: {
            requireGuest: true,
            pageKey: 'onboarding',
        },
    },
    {
        path: '/get-started',
        name: 'onboardingGetStarted',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/onboarding/GetStartedPage.vue'),
        meta: {
            requireGuest: true,
            pageKey: 'onboarding',
        },
    },
        {
        path: '/demo',
        name: 'demo',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/onboarding/RequestDemoPage.vue'),
        meta: {
            requireGuest: true,
            pageKey: 'onboarding',
        },
    },
    {
        path: '/signup',
        name: 'signup',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/onboarding/SignupUserPage.vue'),
        meta: {
            requireGuest: true,
            pageKey: 'onboarding',
        },
    },
    {
        path: '/signup/subscription',
        name: 'signupSubscription',
        component: () => import(/* webpackChunkName: "site" */ '../views/site/onboarding/SignupSubscriptionPage.vue'),
        meta: {
            pageKey: 'onboarding',
        },
    },
    {
        // Page for generating company reports in iframe
        // This needs to be outside of the /company route
        path: '/company/report',
        name: 'CompanyReport',
        component: () => import(/* webpackChunkName: "company" */ '../views/company/report/components/Report.vue'),
        meta: {
            pageKey: 'app',
        }
    },
    {
        path: '/company',
        component: () => import(/* webpackChunkName: "company" */ '../views/company'),
        children: [
            {
                path: '/',
                redirect: 'dashboard',
                meta: {
                    pageKey: 'app',
                },
            },
            {
                path: 'dashboard',
                name: 'CompanyDashboardPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/CompanyDashboardPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                // Page for generating company reports in iframe
                path: 'report',
                name: 'CompanyReport',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/report/components/Report.vue'),
                meta: {
                    pageKey: 'app',
                },
            },
            {
                path: 'clients',
                name: 'ClientListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/client/ClientListPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'clients/:id/edit',
                name: 'ClientEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/client/ClientEditPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'clients/create',
                name: 'ClientCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/client/ClientCreatePage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'projects',
                name: 'ProjectListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/project/ProjectListPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'projects/create',
                name: 'ProjectCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/project/ProjectCreatePage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'projects/:id/edit',
                name: 'ProjectEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/project/ProjectEditPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'work-orders',
                name: 'WorkOrderListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/workOrder/WorkOrderListPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'work-orders/:id/edit',
                name: 'WorkOrderEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/workOrder/WorkOrderEditPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'work-orders/create',
                name: 'WorkOrderCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/workOrder/WorkOrderCreatePage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'tickets',
                name: 'TicketListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/ticket/TicketListPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'tickets/:id/edit',
                name: 'TicketEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/ticket/TicketEditPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'tickets/create',
                name: 'TicketCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/ticket/TicketCreatePage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'drivers',
                name: 'DriverListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/driver/DriverListPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'drivers/:id/edit',
                name: 'DriverEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/driver/DriverEditPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'drivers/create',
                name: 'DriverCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/driver/DriverCreatePage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'managers',
                name: 'ManagerListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/manager/ManagerListPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'managers/:id/edit',
                name: 'ManagerEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/manager/ManagerEditPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'managers/create',
                name: 'ManagerCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/manager/ManagerCreatePage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'equipment',
                name: 'VehicleListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/vehicle/VehicleListPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'equipment/:id/edit',
                name: 'VehicleEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/vehicle/VehicleEditPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'equipment/create',
                name: 'VehicleCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/vehicle/VehicleCreatePage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'materials',
                name: 'MaterialListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/material/MaterialListPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'materials/:id/edit',
                name: 'MaterialEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/material/MaterialEditPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'materials/create',
                name: 'MaterialCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/material/MaterialCreatePage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'sites',
                name: 'SiteListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/site/SiteListPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'sites/:id/edit',
                name: 'SiteEditPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/site/SiteEditPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'sites/create',
                name: 'SiteCreatePage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/site/SiteCreatePage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'reports',
                name: 'ReportListPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/report/ReportListPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'reports/view',
                name: 'ReportViewPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/report/ReportViewPage.vue'),
                meta: {
                    requireCompany: true,
                    requireSubscription: true,
                    pageKey: 'app',
                },
            },
            {
                path: 'billing',
                name: 'BillingPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/settings/BillingPage.vue'),
                meta: {
                    requireCompany: true,
                    pageKey: 'settings',
                },
            },
            {
                path: 'settings',
                name: 'SettingsPage',
                component: () => import(/* webpackChunkName: "company" */ '../views/company/settings/SettingsPage.vue'),
                meta: {
                    requireCompany: true,
                    pageKey: 'settings',
                },
            },
            {
                path: 'admin',
                name: 'AdminSettingsPage',
                component: () => import(/* webpackChunkName: "admin" */ '../views/company/admin/AdminSettingsPage.vue'),
                meta: {
                    requireCompany: true,
                    requireAdmin: true,
                    pageKey: 'settings',
                },
            },
        ],
    },
    {
        path: '/admin',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin'),
        children: [
            {
                path: '/',
                redirect: 'dashboard',
                meta: {
                    pageKey: 'admin',
                },
            },
            {
                path: 'dashboard',
                name: 'AdminDashboardPage',
                component: () => import(/* webpackChunkName: "admin" */ '../views/admin/AdminDashboardPage.vue'),
                meta: {
                    requireAdmin: true,
                    pageKey: 'admin',
                },
            },
            {
                path: 'companies',
                name: 'CompanyListPage',
                component: () => import(/* webpackChunkName: "admin" */ '../views/admin/CompanyListPage.vue'),
                meta: {
                    requireAdmin: true,
                    pageKey: 'admin',
                },
            },
        ],
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
});

router.beforeEach(async (to, from, next) => {
    const { user } = store.state.auth;

    if (to.matched.some(record => record.meta.requireGuest)) {
        if (!user) {
            return next();
        }

        return next({ path: '/company/dashboard' });
    }

    if (to.matched.some(record => record.meta.requireCompany)) {
        if (!user || !['manager', 'owner', 'admin'].includes(user.role)) {
            return next({ path: '/login' });
        }

        if (!store.state.company.id) {
            await store.dispatch('company/fetchOverview');
        }

        const isFreePlan = store.state.company.isFree;
        const requiresSubscription = !isFreePlan && !store.state.company.subscription;
        if (user.role !== 'admin') {
            if (store.state.company.isEnterprise && requiresSubscription) {
                return next({ path: '/enterprise/welcome' });
            }

            if (user.role === 'owner' && requiresSubscription) {
                return next({ path: '/signup/subscription' });
            }
        }
    }

    if (to.matched.some(record => record.meta.requireSubscription)) {
        if (store.getters['company/subscriptionSuspended'] && user.role !== 'admin') {
            return next({ path: '/company/settings' });
        }
    }

    if (to.matched.some(record => record.meta.requireAdmin)) {
        if (!user || user.role !== 'admin') {
            return next({ path: '/login' });
        }
    }

    next();
});

export default router;
